import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  support: defineAsyncComponent(() => import("/app/layouts/support.vue").then(m => m.default || m)),
  "support-kb": defineAsyncComponent(() => import("/app/layouts/supportKb.vue").then(m => m.default || m))
}